export const singleViewnew = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="3" width="14" height="8" fill="white"/>
</svg>`;
